import React from 'react';
import PropTypes from 'prop-types';
import { RangePicker } from 'components/RangePicker/RangePicker';
import { CreditsRangeLabel } from './CreditsRangeLabel';
import { CREDITS_FILTER_MIN_CREDITS, CREDITS_FILTER_MAX_CREDITS } from '../../Search.constants';
import { getCreditsFilterDisplayValues, getCreditsFilterValue, creditsRangeShape } from '../../filters/filters.helpers';
import css from './CreditsFilterOptions.scss';

export class CreditsFilterOptions extends React.Component {
  constructor(props) {
    super(props);

    this.handleCreditRangeChange = this.handleCreditRangeChange.bind(this);
  }

  handleCreditRangeChange([selectedLow, selectedHigh]) {
    const { onCreditRangeChanged } = this.props;

    const creditFilterValue = getCreditsFilterValue(selectedLow, selectedHigh);

    onCreditRangeChanged(creditFilterValue);
  }

  render() {
    const { creditsRange } = this.props;

    const displayValues = getCreditsFilterDisplayValues(creditsRange);

    return (
      <div className="pv ph">
        <div className={css.range}>
          <CreditsRangeLabel creditsRange={creditsRange} />
        </div>
        <RangePicker
          min={CREDITS_FILTER_MIN_CREDITS}
          max={CREDITS_FILTER_MAX_CREDITS}
          onChange={this.handleCreditRangeChange}
          onChangeEnd={this.handleCreditRangeChange}
          value={displayValues}
        />
      </div>
    );
  }
}
CreditsFilterOptions.propTypes = {
  onCreditRangeChanged: PropTypes.func.isRequired,
  creditsRange: creditsRangeShape,
};
